import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text, Button } from 'modules/common';

import * as c from './constants';

function EmptyState({
  title,
  description,
  footer,
  withButtonText,
  buttonTextProps,
  imageClassName,
  titleTextProps,
  descriptionTextProps,
  containerClassName,
  className,
  imageSize,
  imageElement,
}) {
  const footerProps = {
    primaryButtonProps: {
      className: 'ds-btn ds-primary ds-sm',
    },
    secondaryButtonProps: {
      className: 'ds-btn ds-sm',
    },
  };

  return (
    <div className={cn('flex flex-col items-center p-5', containerClassName)}>
      <div
        className={cn(
          'flex flex-col items-center w-full max-w-[300px]',
          className,
          description ? 'gap-ds-24' : 'gap-ds-16'
        )}
      >
        <div
          className={cn('flex justify-center', imageClassName)}
          style={{
            ...(imageSize && {
              height: imageSize,
              width: imageSize,
            }),
          }}
        >
          {imageElement || c.emptyStateLogo}
        </div>

        <div className="flex flex-col gap-ds-8 text-center">
          {Boolean(title) && (
            <Text
              type="subheading"
              weight="bold"
              color="primitive-black"
              {...titleTextProps}
            >
              {title}
            </Text>
          )}

          {Boolean(description) && (
            <Text leading="relaxed" color="muted" {...descriptionTextProps}>
              {description}
            </Text>
          )}
        </div>

        {footer && (
          <div className="flex items-center gap-ds-8">
            {typeof footer === 'function' ? footer(footerProps) : footer}
          </div>
        )}

        {withButtonText && (
          <Button
            label="Get Help"
            className="font-semibold"
            type="info"
            variant="text"
            {...buttonTextProps}
          />
        )}
      </div>
    </div>
  );
}

export default EmptyState;

EmptyState.defaultProps = {
  title: 'No items found',
  description: '',
  footer: false,
  withButtonText: false,
  buttonTextProps: {},
  titleTextProps: {},
  descriptionTextProps: {},
  imageClassName: '',
  imageSize: '80px',
  className: '',
  containerClassName: '',
  imageElement: false,
};

EmptyState.propTypes = {
  withButtonText: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  imageSize: PropTypes.string,
  containerClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  buttonTextProps: PropTypes.instanceOf(Object),
  titleTextProps: PropTypes.instanceOf(Object),
  descriptionTextProps: PropTypes.instanceOf(Object),
  description: PropTypes.string,
  footer: PropTypes.oneOfType([
    PropTypes.instanceOf(Function),
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  imageElement: PropTypes.oneOfType([
    PropTypes.instanceOf(Function),
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};
